export default {
    path: 'system',
    name: 'systemForm',
    component() {
        return import('@/components/system/management/systemManagementForm.vue');
    },
    children:[
        {
            path: '',
            name: 'RoleUserForm',
            component() {
                return import('@/components/system/management/user/RoleUserForm.vue');
            }
        },
        {
            path: 'major',
            name: 'majorList',
            component(){
                return import('@/components/system/management/major/MajorList.vue');
            }
        },
        {
            path: 'volunteerOnOff',
            name: 'VolunteerOnOffCampusScore',
            component() {
                return import('@/components/system/management/volunteerOnOffCampusScore/VolunteerOnOffCampusScoreList.vue');
            }
        },
        {
            path: 'volunteerOnCampus',
            name: 'volunteerOnCampusPropagateScoreList',
            component() {
                return import('@/components/system/management/volunteerOnCampusPropagateScore/VolunteerOnCampusPropagateScoreList.vue');
            }
        },
        {
            path:'achievementScore',
            name:'AchievementScoreForm',
            component(){
                return import('@/components/system/management/achievementScore/AchievementScoreForm.vue');
            }
        },
        {
            path:'achievementScoreRatio',
            name:'AchievementScoreRatioForm',
            component(){
                return import('@/components/system/management/achievementScoreRatio/AchievementScoreRatioForm.vue');
            }
        },
        {
            path:'journal',
            name:'JournalManagementList',
            component(){
                return import('@/components/system/management/journalManagement/JournalManagementList.vue');
            }
        },
        {
            path: 'achvmPlan',
            name: 'AchvmPlanMngList',
            component() {
                return import('@/components/system/management/achvmPlan/AchvmPlanMngList.vue');
            }
        },
        {
            path: 'achvmPlan/:seqnr',
            name: 'AchvmPlanMngDetail',
            component() {
                return import('@/components/system/management/achvmPlan/AchvmPlanMngDetail.vue');
            }
        },
        {
            path: 'judgementTarget',
            name: 'JudgementTargetList',
            component() {
                return import('@/components/system/management/judgementTarget/JudgementTargetList.vue')
            },
        }
    ],
}